import React, { useState } from 'react';
import { auth } from '../lib/firebase';

function LoginScreen() {
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');

  const signIn = async () => {
    setLoading(true); setError('');
    try {
      const provider = new firebase.auth.GoogleAuthProvider();
      await auth.signInWithPopup(provider);
    } catch(e) {
      setError('Falha no login. Tente novamente.');
      setLoading(false);
    }
  };

  const signInEmail = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError('Preencha e-mail e senha.'); return; }
    setLoading(true); setError('');
    try {
      await auth.signInWithEmailAndPassword(email.trim(), password);
    } catch(err) {
      const msgs = {
        'auth/invalid-email':        'E-mail inválido.',
        'auth/user-not-found':       'Usuário não encontrado.',
        'auth/wrong-password':       'Senha incorreta.',
        'auth/invalid-credential':   'E-mail ou senha incorretos.',
        'auth/too-many-requests':    'Muitas tentativas. Aguarde alguns minutos.',
        'auth/user-disabled':        'Conta desativada.',
      };
      setError(msgs[err.code] || 'Falha no login. Verifique os dados.');
      setLoading(false);
    }
  };

  const resetPassword = async () => {
    if (!email) { setError('Digite seu e-mail para receber o link de redefinição.'); return; }
    try {
      await auth.sendPasswordResetEmail(email.trim());
      setError('');
      alert('Link de redefinição enviado para ' + email.trim());
    } catch(err) {
      setError('Não foi possível enviar o e-mail de redefinição.');
    }
  };

  return <div className="min-h-screen flex items-center justify-center p-4" style={{background:'linear-gradient(145deg,#1C1C1E 0%,#2C2C2E 50%,#1C1C1E 100%)'}}>
    <div className="animate-sheet acard rounded-3xl shadow-2xl p-10 w-full max-w-sm text-center">
      <div className="w-16 h-16 rounded-2xl bg-blue-500 flex items-center justify-center mx-auto mb-5 shadow-lg" style={{boxShadow:'0 8px 24px rgba(0,122,255,0.35)'}}>
        <svg className="w-8 h-8 text-white fill-current" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      </div>
      <h1 className="t-title-2 font-bold text-gray-900 tracking-tight mb-1">Pipeline Leads</h1>
      <p className="text-sm text-gray-400 mb-8">Faça login para acessar seu pipeline</p>
      {error && <div className="bg-red-50 text-red-600 text-sm rounded-2xl px-4 py-2.5 mb-4 border border-red-100">{error}</div>}

      {!showEmail ? (
        <>
          <button onClick={signIn} disabled={loading}
            className="w-full acard rounded-2xl py-3 px-4 font-semibold text-sm text-gray-700 hover:bg-gray-50 transition-all flex items-center justify-center gap-3 disabled:opacity-50 shadow-sm">
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {loading ? 'Aguardando...' : 'Continuar com Google'}
          </button>

          <div className="flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-gray-200" />
            <span className="text-xs text-gray-300 font-medium">ou</span>
            <div className="flex-1 h-px bg-gray-200" />
          </div>

          <button onClick={()=>{setShowEmail(true); setError('');}}
            className="w-full rounded-2xl py-3 px-4 font-semibold text-sm text-blue-600 hover:bg-blue-50 transition-colors border border-blue-200">
            📧 Entrar com e-mail e senha
          </button>
        </>
      ) : (
        <form onSubmit={signInEmail} className="space-y-3">
          <input
            type="email" value={email} onChange={e=>setEmail(e.target.value)}
            placeholder="seu@email.com" autoComplete="username" autoFocus
            className="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
          />
          <input
            type="password" value={password} onChange={e=>setPassword(e.target.value)}
            placeholder="Senha" autoComplete="current-password"
            className="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent"
          />
          <button type="submit" disabled={loading}
            className="w-full bg-blue-500 text-white rounded-2xl py-3 px-4 font-semibold text-sm hover:bg-blue-600 transition-colors disabled:opacity-50 shadow-sm">
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
          <div className="flex items-center justify-between pt-1">
            <button type="button" onClick={()=>{setShowEmail(false); setError(''); setPassword('');}}
              className="text-xs text-gray-400 hover:text-gray-600 transition-colors">
              ← Voltar
            </button>
            <button type="button" onClick={resetPassword}
              className="text-xs text-blue-500 hover:text-blue-700 transition-colors">
              Esqueci a senha
            </button>
          </div>
        </form>
      )}

      <p className="text-xs text-gray-300 mt-6">Produxia · Maximizy · HomePlay</p>
    </div>
  </div>;
}

// ─── UnauthorizedScreen ───────────────────────────────────

function UnauthorizedScreen({ user }) {
  return <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
    <div className="bg-white rounded-3xl shadow-xl p-10 w-full max-w-sm text-center">
      <div className="text-5xl mb-4">🔒</div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">Acesso não autorizado</h2>
      <p className="text-sm text-gray-500 mb-2">O e-mail <strong>{user.email}</strong> não tem permissão de acesso.</p>
      <p className="text-xs text-gray-400 mb-6">Entre em contato com o administrador.</p>
      <button onClick={()=>auth.signOut()} className="bg-gray-800 text-white rounded-xl py-2 px-6 text-sm font-medium hover:bg-gray-700">Sair</button>
    </div>
  </div>;
}

// ─── AccessCheckFailedScreen ──────────────────────────────
// A leitura do acesso falhou (rede, extensão, sessão velha). Não é falta de
// permissão, então não pode dizer "não autorizado": oferece tentar de novo.

function AccessCheckFailedScreen({ user, erro, onRetry }) {
  return <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
    <div className="bg-white rounded-3xl shadow-xl p-10 w-full max-w-sm text-center">
      <div className="text-5xl mb-4">⚠️</div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">Não consegui verificar seu acesso</h2>
      <p className="text-sm text-gray-500 mb-2">A conexão com o painel falhou para <strong>{user.email}</strong>. Isso costuma ser internet instável ou uma extensão do navegador bloqueando o painel.</p>
      <p className="text-xs text-gray-400 mb-6">Código: {erro}</p>
      <div className="flex gap-2 justify-center">
        <button onClick={onRetry} className="bg-blue-600 text-white rounded-xl py-2 px-6 text-sm font-medium hover:bg-blue-700">Tentar de novo</button>
        <button onClick={()=>auth.signOut()} className="bg-gray-100 text-gray-700 rounded-xl py-2 px-6 text-sm font-medium hover:bg-gray-200">Sair</button>
      </div>
    </div>
  </div>;
}

// ─── Empresas disponíveis ─────────────────────────────────

export { LoginScreen, UnauthorizedScreen, AccessCheckFailedScreen };
